import placeholder from "./Placeholder.module.css";

/**
 * Sample text drawn as a soft bar while a page loads. It is the length of the text it stands in for and wraps the same
 * way, so the placeholder takes the space the real text will and the page does not move when the data arrives. Hide it
 * from assistive technology with the rest of the loading layout; the spinner's label says what is loading.
 *
 * @param props.children - Text of about the length of what will appear.
 */
export function PlaceholderText({ children }: { children: string }): React.JSX.Element {
  return <span className={placeholder.text}>{children}</span>;
}
